module.exports = __webpack_public_path__ + "img/LiveTest.a75f0d19.svg";